import { marked } from 'marked'
import sanitize from 'widget-components/utilities/sanitize'

const renderer = new marked.Renderer()

renderer.link = (href, title, text) => `<a target="_blank" href="${href}" title="${title ?? ''}">${text}</a>`

export default (text = '') => marked.parseInline(sanitize(text), { renderer })
